export const status = {
  ALL: 'ALL',
  WAITING: 'WAITING',
  PENDING: 'PENDING',
  LATED: 'LATED',
  CANCELED: 'CANCELED',
  SUCCESS: 'SUCCESS',
}

export const statusText = {
  ALL: 'ทั้งหมด',
  WAITING: 'รอการดำเนินการ',
  PENDING: 'กำลังดำเนินการ',
  LATED: 'เลยกำหนดการ',
  CANCELED: 'ยกเลิก',
  SUCCESS: 'สำเร็จ',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const unitVar = [
  {
    value: 'TON',
    text: 'ตัน',
  }, {
    value: 'KG',
    text: 'กิโลกรัม',
  }, {
    value: 'H50',
    text: 'กระสอบ 50 กิโลกรัม',
  }, {
    value: 'TRIP',
    text: 'เที่ยว',
    disabled: true,
  },
]

export const unitText = {
  TON: 'ตัน',
  KG: 'กิโลกรัม',
  H50: 'กระสอบ 50 กิโลกรัม',
  TRIP: 'เที่ยว',
  // H60: 'กระสอบ 60 กิโลกรัม',
  // H100: 'กระสอบ 100 กิโลกรัม',
}

export const unitValue = {
  TON: 'TON',
  KG: 'KG',
  H50: 'H50',
  TRIP: 'TRIP',
  // H60: 'H60',
  // H100: 'H100',
}
